import {
  PlanForm,
  TeamOverride,
  CustomGroupOverride,
  AreaOverride,
  PlanDetails,
  CreatePlan,
  MassUpdate,
  PlanBuilder,
  Plans,
} from '@/modules/AdminTools/modules/PlanBuilder';

import { abilityConstants } from '@/lib';

const { ACCESS_PLAN_BUILDER_ABILITY } = abilityConstants;

export const PATH = '/plan-builder';

export const MASS_UPDATE = `${PATH}/mass-update`;

export const PLAN_PATH = `${PATH}/plan/`;

const planPath = (path) => {
  path = path ? `${path}` : '';
  let out = `${path?.startsWith(PLAN_PATH) ? '' : PLAN_PATH}${path}`;
  out = `${out}${out?.endsWith('/') ? '' : '/'}`;

  return out;
};

export const editPlan = (path) => `${planPath(path)}edit/`;

export const optionalPricing = (path, groupType) => `${planPath(path)}${groupType}/`;

export const NAME = 'Plans';

export const routes = (protectedRoute, layout) => ({
  path: PATH,
  element: layout,
  children: [
    {
      element: protectedRoute(<PlanBuilder />, ACCESS_PLAN_BUILDER_ABILITY),
      children: [
        {
          index: true,
          element: <Plans />,
        },
        {
          path: MASS_UPDATE,
          element: <MassUpdate />,
        },
        {
          path: PLAN_PATH,
          element: <CreatePlan />,
        },
        {
          path: editPlan(':id'),
          element: <PlanForm />,
          children: [
            {
              index: true,
              element: <PlanDetails />,
            },
            {
              path: optionalPricing(editPlan(':id'), 'area'),
              element: <AreaOverride />,
            },
            {
              path: optionalPricing(editPlan(':id'), 'team'),
              element: <TeamOverride />,
            },
            {
              path: optionalPricing(editPlan(':id'), 'group'),
              element: <CustomGroupOverride />,
            },
          ],
        },
      ],
    },
  ],
});
